import * as React from "react";
import classnames from "classnames";
import { Modal, IconButton, RichTextArea } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css               */
const InfoModal = ({
  isOpen,
  onModalClose,
  image,
  footer,
  className,
  title,
  richTextContent,
  content,
  children
}) => {
  return /* @__PURE__ */ React.createElement(Modal, { className: "info-modal", isOpen, onModalClose, footer }, /* @__PURE__ */ React.createElement("div", { className: "info-modal" }, /* @__PURE__ */ React.createElement(
    "header",
    {
      className: classnames("info-modal__header", {
        [`${className}__header`]: !!className
      })
    },
    title && /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2", className: "info-modal__title" }, title),
    /* @__PURE__ */ React.createElement(IconButton, { className: "info-modal__close", onClick: onModalClose }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }))
  ), /* @__PURE__ */ React.createElement("div", { className: "info-modal__container" }, image && /* @__PURE__ */ React.createElement("img", { className: "info-modal__container__image", src: image.url, alt: image.alt }), content && /* @__PURE__ */ React.createElement(Text, { variant: "body" }, content), richTextContent && /* @__PURE__ */ React.createElement(RichTextArea, { className: "info-modal__container__richText", content: richTextContent }), children)));
};
export {
  InfoModal as default
};
//# sourceMappingURL=InfoModal.js.map
